import { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../../components/ui/dialog';
import { Drawer, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle } from '../../../components/ui/drawer';
import { Checkbox } from '../../../components/ui/checkbox';
import { Textarea } from '../../../components/ui/textarea';
import { Button } from '../../../components/ui/button';
import ModalCloseButton from '../../../components/generic/ModalCloseButton';
import { useIsTablet } from '../../../lib/useIsTablet';

const ReportSolutionModal = ({ open, onClose, reportOptions, onSubmit, isSubmitting }) => {
  const [selected, setSelected] = useState([]);
  const [description, setDescription] = useState('');
  const isTablet = useIsTablet();

  const toggleOption = (option) => {
    setSelected((prev) => (prev.includes(option) ? prev.filter((item) => item !== option) : [...prev, option]));
  };

  const handleClose = () => {
    setSelected([]);
    setDescription('');
    onClose();
  };

  const handleSubmit = async () => {
    if (selected.length === 0) return;
    await onSubmit({ reports: selected, description: description || undefined });
    handleClose();
  };

  const renderBody = () => (
    <div className="flex flex-col gap-4">
      <div className="bg-[var(--q3-danger-light)] text-[var(--q3-neutral-default)] border border-dashed border-[var(--q3-danger-normal)] p-3 text-sm rounded-md">
        Do not report solution if you think it is incorrect, simply downvote it.
      </div>
      <div className="flex flex-col gap-2">
        {(reportOptions || []).map((option) => (
          <label key={option} className="flex items-center gap-2 cursor-pointer text-sm">
            <Checkbox checked={selected.includes(option)} onCheckedChange={() => toggleOption(option)} />
            {option}
          </label>
        ))}
      </div>

      <Textarea
        placeholder="Add more detail (optional)"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      <Button
        className="w-full mt-2 rounded-full bg-[var(--q3-accent-normal)] text-[var(--q3-neutral-default_inverted)] hover:scale-100 hover:bg-[var(--q3-accent-dark)]"
        disabled={selected.length === 0 || isSubmitting}
        onClick={handleSubmit}
      >
        Submit
      </Button>
    </div>
  );

  if (isTablet) {
    return (
      <Dialog open={open} onOpenChange={(isOpen) => !isOpen && handleClose()}>
        <DialogContent className="min-w-[560px] rounded-3xl" showCloseButton={false}>
          <ModalCloseButton onClick={handleClose} />
          <DialogHeader>
            <DialogTitle>Report Error</DialogTitle>
            <DialogDescription>Please select your reason to report</DialogDescription>
          </DialogHeader>
          {renderBody()}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={open} onOpenChange={(isOpen) => !isOpen && handleClose()}>
      <DrawerContent showCloseButton={false} className="px-4 pb-6 max-h-[90vh]">
        <ModalCloseButton onClick={handleClose} />
        <DrawerHeader>
          <DrawerTitle>Report Error</DrawerTitle>
          <DrawerDescription>Please select your reason to report</DrawerDescription>
        </DrawerHeader>
        <div className="overflow-y-auto">{renderBody()}</div>
      </DrawerContent>
    </Drawer>
  );
};

export default ReportSolutionModal;
